export default {"SERVER_URL":"api.bytenite.com","API_VERSION":"v1","NODE_ENV":"development","PROTOCOL":"https", "AUTH_SERVER":"https://auth.bytenite.com/"};
